import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import InfoSection from '@/components/Approval/@components/InfoSection';
import { Body2 } from '@/components/@IntranetLibrary/Typography';
import { parseWorkSpecificationChecklist } from '@/utils/approval/workSpecification';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

const ChecklistList = styled('ul')`
  margin: 0;
  padding-left: 20px;
  list-style: disc;
`;

/** 작업사양서(183) — 저장된 문구 그대로 */
const WorkSpecificationSlot = ({ data }: ContentExtraProps) => {
  const { t } = useTranslation();
  const checklist = useMemo(
    () => parseWorkSpecificationChecklist(data.attributes),
    [data.attributes],
  );
  if (!checklist?.length) return null;
  return (
    <ContentSlotRoot>
      <InfoSection title={t('체크리스트')}>
        <ChecklistList>
          {checklist.map((item) => (
            <li key={item}>
              <Body2>{item}</Body2>
            </li>
          ))}
        </ChecklistList>
      </InfoSection>
    </ContentSlotRoot>
  );
};

export default WorkSpecificationSlot;
